const waveCartUtils = (function () {
  function post (url, body) {
    return fetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  function get (url) {
    return fetch(url, {
      credentials: "same-origin",
      method: "GET",
    });
  }

  function getCart () {
    var url = "".concat(theme.routes.cart, `?t=${Date.now()}`);
    return get(url).then((response) => response.json());
  }

  function changeItem ({
    key,
    quantity,
    properties,
  }) {
    return post(theme.routes.cartChange, {
      id: key,
      quantity: quantity,
      properties: properties,
    });
  }

  function addItems (
    items,
    sections,
    sections_url,
  ) {
    return post(theme.routes.cartAdd, {
      items,
      sections,
      sections_url,
    });
  }

  async function clearAddOn () {
    const cart = await getCart();
    const unissuedAddOns = cart.items.filter((item) => {
      return (
        item.properties["__add_on"] && !item.properties["__add_on"]["issued"]
      );
    });

    const param = { updates: {} };
    for (const item of unissuedAddOns) {
      param.updates[item.key] = 0;
    }
    if (unissuedAddOns.length > 0) {
      await post(theme.routes.cartUpdate, param);
    }
    return unissuedAddOns.length > 0;
  }

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
  }

  return {
    changeItem: changeItem,
    getCart: getCart,
    addItems: addItems,
    clearAddOn: clearAddOn,
    getRandomInt: getRandomInt
  };
})();

class wcAddonPopup extends HTMLElement {
  constructor() {
    super();

    const _this = this;
    this.querySelectorAll('.js-close-addon-popup').forEach(ele => {
      ele.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        _this.hide();
      })
    })

    document.addEventListener('wcAddonPopup:lock', async (e) => {
      _this.lock();
    });
    document.addEventListener('wcAddonPopup:unlock', async (e) => {
      _this.unlock();
    });
    document.addEventListener('wcAddonPopup:open', async (e) => {
      const productHandle = e?.detail?.productHandle;
      if (!productHandle) return;
      this.showAndRender(productHandle);
    });

    document.addEventListener('wcAddonPopup:refresh', this.refresh.bind(this));

    document.addEventListener('ajaxProduct:added', async (e) => {
      const productHandle = e?.detail?.isAddon ? this.productHandle : e?.detail?.product?.handle;
      if (!productHandle) return;

      if (e?.detail?.isAddon) {
        this.showAndRender(productHandle, e?.detail?.popupHtml);
      } else {
        const el = document.createElement('div');
        el.innerHTML = e?.detail?.popupHtml || await this.fetchPopup(productHandle);
        const autoAddGifts = el.querySelectorAll('[data-auto-add-gift]')
        
        await this.autoAddGiftsToCart(autoAddGifts);
      }
    });
    
    document.addEventListener('wcAddonPopup:qtyUpdated', async (e) => {
      const productHandle = e?.detail?.productHandle;
      if (!productHandle) return;
  
      const popupHtml = await this.fetchPopup(productHandle);
      const el = document.createElement('div');
      el.innerHTML = popupHtml;
  
      const autoAddGifts = el.querySelectorAll('[data-auto-add-gift]')
      if (autoAddGifts.length > 0) {
        await this.autoAddGiftsToCart(autoAddGifts);
      }
    });
  }

  async refresh() {
      if (!this.productHandle) return;
      this.showAndRender(this.productHandle);
  }

  async showAndRender(productHandle, popupHtml) {
    popupHtml = popupHtml || await this.fetchPopup(productHandle);

    const el = document.createElement('div');
    el.innerHTML = popupHtml;
    const isEmpty = el.querySelector('.addon-collection-row') == null;

    if (!isEmpty) {
      this.productHandle = productHandle;
      this.show();
      this.render(popupHtml);
    }
  }

  async autoAddGiftsToCart(gifts) {
    const itemsToAdd = [];
    gifts.forEach(async gift => {
      const usedCount = parseInt(gift.dataset.usedCount);
      const quota = parseInt(gift.dataset.quota);

      if (usedCount < quota) {
        const rule = JSON.parse(gift.dataset.rule);
        delete rule.issued_count;
        itemsToAdd.push({
          quantity: quota - usedCount,
          id: parseInt(gift.dataset.variantId),
          properties: {
            __add_on: {
              rule: rule,
              set: gift.dataset.addonSet,
            }
          }
        });
      }
    });
    if (itemsToAdd.length > 0) {
      const resp = await waveCartUtils.addItems(itemsToAdd, '', '');
      if (resp.status === 422) {
        // Handle error
      } else {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    }
  }

  lock () {
    this.dataset.lockCount = parseInt(this.dataset.lockCount) + 1;
  }

  unlock () {
    this.dataset.lockCount = parseInt(this.dataset.lockCount) - 1;
  }

  show () {
    document.body.classList.add('overflow-hidden');
    this.style.display = 'block';
  }

  hide () {
    document.body.classList.remove('overflow-hidden');
    this.style.display = 'none';
    this.querySelector('.popup-content').innerHTML = '';
  }

  async fetchPopup (productHandle) {
    const sectionName = 'addon-popup-content';
    const url = `${theme.routes.home}/products/${productHandle}?sections=addon-popup-content`.replace('//', '/');
    // const url = 'https://neweracap.hk/products_preview?preview_key=b01c4d398643d44bc58d6590cc872873&sections=addon-popup-content';
    const resp = await fetch(url);
    const json = await resp.json();
    return json[sectionName];
  }

  render (popupHtml) {
    let tempElement = document.createElement('div');
    this.querySelector('.popup-content').innerHTML = popupHtml;
    if (this.querySelector('.addon-collection-row:not(.disabled)') == null) {
      this.hide()
    }
  }
}
customElements.define('wc-addon-popup', wcAddonPopup);

class wcAddonQuickAddButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button.add-to-cart');
  }

  connectedCallback() {
    if (this.closest('wc-addon-popup') == null) {
      this.remove();
      return;
    }

    const form = this.querySelector('form');
    const tmp = this.closest('[data-rule]');
    this.productForm = new theme.AjaxProduct(form, '.add-to-cart', {
      isAddon: true,
      sections: 'addon-popup-content',
      sections_url: `${theme.routes.home}/products/${tmp.dataset.qualifyingProductHandle}`.replace('//', '/')
    });
    const addonSet = tmp.dataset.addonSet;
    const addonPropertyInput = document.createElement('input');
    addonPropertyInput.hidden = true;
    const promoRule = JSON.parse(this.closest('[data-rule]').dataset.rule);
    addonPropertyInput.value = JSON.stringify({
      rule: promoRule,
      set: addonSet,
    });
    addonPropertyInput.name = 'properties[__add_on]';
    form.appendChild(addonPropertyInput);
  }

  updateVariant(variant) {
    const cartBtn = this.button;
    const cartBtnText = cartBtn.querySelector('[data-add-to-cart-text]');
    const classes = { disabled: 'disabled' };
    if (!variant) {
      cartBtn.classList.add(classes.disabled);
      cartBtn.disabled = true;
      cartBtnText.textContent = theme.strings.unavailable;
    } else if (variant.available) {
        const select = this.querySelector('select.product-single__variants');
        select.value = variant.id;
        // Available, enable the submit button and change text
        cartBtn.classList.remove(classes.disabled);
        cartBtn.disabled = false;
        var defaultText = cartBtnText.dataset.defaultText;
        cartBtnText.textContent = defaultText;
      } else {
        // Sold out, disable the submit button and change text
        cartBtn.classList.add(classes.disabled);
        cartBtn.disabled = true;
        cartBtnText.textContent = theme.strings.soldOut;
    }
  }
}
customElements.define('wc-addon-quick-add-button', wcAddonQuickAddButton);

class wcAddonProductGridItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const variantJson = this.querySelector('[data-variant-json]');
    if (!variantJson) {
      return;
    }

    const variantsObject = JSON.parse(variantJson.innerHTML);
    const _this = this;
    this.addEventListener('wcProductBlock:loaded', function() {
      const options = {
        container: this,
        enableHistoryState: false,
        singleOptionSelector: '[data-variant-input]',
        originalSelectorId: '[data-product-select]',
        variants: variantsObject
      };
      _this.variants = new theme.Variants(options);
      _this.addEventListener('variantChange', function (e) {
        const variant = e.detail.variant;
        _this.querySelectorAll('wc-addon-quick-add-button').forEach(button => {
          button.updateVariant(variant);
        })
      });
    }, { capture: true });
  }
}
customElements.define('wc-addon-product-grid-item', wcAddonProductGridItem);

class wcAddonPopupButton extends HTMLElement {
  constructor() {
    super();

    this.productHandle = this.dataset.productHandle;
    const _this = this;
    this.querySelector('button').addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('wcAddonPopup:open', {
        detail: {
          productHandle: _this.productHandle,
        }
      }));
    });
  }
}
customElements.define('wc-addon-popup-button', wcAddonPopupButton);

class wcLoadMoreButton extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    const parent = this.parentElement;
    if (parent == null) return;
    parent.setAttribute('aria-expanded', parent.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }
}
customElements.define('wc-load-more-button', wcLoadMoreButton);

class wcProductBlockHolder extends HTMLElement {
  constructor() {
    super();

    this.loaded = false;
    const placeholderDiv = this.querySelector('div');
    const _this = this;

    this.querySelector('button').addEventListener('click', async function () {
      if (!_this.loaded) {
        _this.loaded = true;
        const url = _this.dataset.url;
        const html = await fetch(url).then(r => r.text());
        const randomSuffix = `-${waveCartUtils.getRandomInt(0, Number.MAX_SAFE_INTEGER)}`;
        
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var blocks = doc.querySelector('[data-product-blocks]');

        const ids = Array.from(blocks.querySelectorAll('[id]')).map(i => i.getAttribute('id'));
        for (const id of ids) {
          const newId = `${id}${randomSuffix}`;
          blocks.querySelectorAll(`[id="${id}"]`).forEach(i => i.setAttribute('id', newId));
          blocks.querySelectorAll(`[for="${id}"]`).forEach(i => i.setAttribute('for', newId));
          blocks.querySelectorAll(`[aria-controls="${id}"]`).forEach(i => i.setAttribute('aria-controls', newId));
        }

        placeholderDiv.innerHTML = '';
        placeholderDiv.append(blocks);

        _this.dispatchEvent(new CustomEvent('wcProductBlock:loaded', {
          detail: {
          }
        }));
      }

      _this.toggle();
    });
  }

  toggle() {
    this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }
}
customElements.define('wc-product-block-holder', wcProductBlockHolder);

waveCartUtils.clearAddOn().then(updated => {
  if (updated) {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
});
document.addEventListener('cart:updated', async (e) => {
  const updated = await waveCartUtils.clearAddOn();
  
  const key = e?.detail?.key;
  const cart = e?.detail?.cart;
  if (key && cart) {
    const k = key.split(':')[0];
    const item = cart.items.find(item => item.key.startsWith(k));
    if (item && item.handle) {
      document.dispatchEvent(new CustomEvent('wcAddonPopup:qtyUpdated', {
        detail: {
          productHandle: item.handle,
        }
      }));
    }
  }
  
  if (updated) {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
});

class wcRemoveAddonButton extends HTMLElement {
  constructor() {
    super();

    const lineItemId = this.dataset.lineItemId;
    this.querySelector('button').addEventListener('click', async function() {
      const resp = await waveCartUtils.changeItem({
        key: lineItemId,
        quantity: 0
      });
      if (resp.status == 200) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
      document.dispatchEvent(new CustomEvent('wcAddonPopup:refresh'))
    })
  }
}
customElements.define('wc-remove-addon-button', wcRemoveAddonButton);

class wcReminderPopupButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function() {
      document.dispatchEvent(new CustomEvent('wcReminderPopup:open'));
    })

    /*
    if (this.hidden) {
      this.parentElement.classList.remove('hide-checkout');
    } else {
      this.parentElement.classList.add('hide-checkout');
    }
    */
  }
}
customElements.define('wc-reminder-popup-button', wcReminderPopupButton);

class wcReminderPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('wcReminderPopup:open', this.show.bind(this));
    this.querySelector('[data-close-reminder]').addEventListener('click', this.hide.bind(this));
  }

  show() {
    document.body.classList.add('overflow-hidden');
    this.style.display = 'flex';
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.style.display = 'none';
  }
}
customElements.define('wc-reminder-popup', wcReminderPopup);

class wcGroupDiscountBadge extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes () { return ['data-tags']; }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name !== 'data-tags') {
      return;
    }

    const tags = JSON.parse(this.dataset.tags);

    const groupDiscountTag = window.wcGroup ? tags.find(tag => tag.startsWith(window.wcGroup)) : '';
    const groupPercentageOff = groupDiscountTag ? Math.min(100, Number(groupDiscountTag.split('|')[0].split(':')[1].replace('%', ''))) : 0;

    this.render(groupPercentageOff);
  }

  render (amount) {
    if (!amount) return;

    this.innerHTML = `-${amount}%`;
    this.style.display = 'flex';
  }
}
customElements.define('wc-group-discount-badge', wcGroupDiscountBadge);
